import { Link } from "react-router-dom";
import { categories } from "@/mocks/data";

export default function CategoryPreview() {
  return (
    <section className="py-16 md:py-20 bg-background-100/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
            分类浏览
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            按主题分类浏览，快速找到您需要的9170手机版相关内容
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="bg-background-50 rounded-lg p-6 hover:bg-background-50/80 transition-all duration-200 group border border-background-200/60"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-200">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed mb-3">
                {cat.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-400">{cat.articleCount} 篇文章</span>
                <i className="ri-arrow-right-line text-foreground-400 group-hover:text-accent-500 group-hover:translate-x-1 transition-all duration-200"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}